import { atomFamily } from 'recoil'

import { WorkDocSection } from './rest'
import { get, put, del } from './sideEffects.container'

const handleGet = async key => {
  try {
    return await get(key)
  } catch (e) {
    const savedValue = localStorage.getItem(key)

    if (savedValue != null && savedValue != 'undefined') {
      return JSON.parse(savedValue)
    } else {
      return undefined
    }
  }
}

const localStorageEffect =
  key =>
  ({ onSet }) => {
    const handleReset = (key: string) => {
      del(key).catch(() => localStorage.removeItem(key))
    }

    const handleAdd = (key: string, value: any) => {
      const modified = value
        ? { stageId: value.stageId, workDocSection: value.workDocSection }
        : value

      if (modified) {
        put(key, modified).catch(() =>
          localStorage.setItem(key, JSON.stringify(value)),
        )
      }
    }

    onSet((newValue, _, isReset) => {
      isReset ? handleReset(key) : handleAdd(key, newValue)
    })
  }

export const workDocSectionAtom = atomFamily<
  Pick<WorkDocSection, 'workDocSection' | 'stageId'> | undefined,
  string
>({
  key: 'workDocSectionState',
  default: contractId => handleGet(contractId),
  effects: contractId => [localStorageEffect(contractId)],
})
